import createStory from '../createStory';
import introducing from './introducing.png';

const title = "Introducing E-Florals"
const shortName = "eflorals"
const preview = "We partnered with Cerise Technology to build E-Florals, a web app built for relaxation and gratitude"
const author = "Claire"

const element0 = <img src={introducing} alt="a pink striped awning reading Introducing E-Florals" className="storyTitleImage" />
const element1 = <p className="storyBodyText"> We partnered with Cerise Technology to build E-Florals, a web app built for relaxation and gratitude. Using E-Florals, you can send someone a free, digital bouquet designed and customized just for them, with a special note attached, in an unexpected, day-brightening way. You get to choose from a variety of different types and colors of flowers to build the perfect creation. The process is calming and aesthetic, designed to reduce stress and boost creativity. </p>
const element2 = <p className="storyBodyText"> Try it out at <a className="storyResourceText" href="https://e-florals.com/"> e-florals.com</a> and let us know what you think!</p>
const story=[element0, element1, element2]
const eflorals = createStory (shortName, title, preview, author, story)

export default eflorals;